import React from "react";
import { supportEmail } from "../../../constants";

/**
 * Warning plus the support-email line used when a public class cannot be used.
 * Callers keep their own page title and card wrapper.
 */
const ClassUnavailableNotice: React.FC<{ message: string }> = ({ message }) => (
  <>
    <div className="alert alert-warning mb-3" role="alert">
      {message}
    </div>
    <p className="mb-0">
      Please contact <a href={`mailto:${supportEmail}`}>{supportEmail}</a> for
      further assistance.
    </p>
  </>
);

export default ClassUnavailableNotice;
